/**
 * A townsperson of the quests: peaceful, standing still, named in green, the
 * quests' scroll on the maps. `extra` overrides any field (a stroll, a map
 * pictogram of its own, a nameplate off).
 */
export function townsperson(id, name, extra = {}) {
    return {
        id,
        name,
        bodyKey: `body.${id}`,
        tilesPerSecond: 2,
        health: 1,
        damage: 0,
        attackIntervalMs: 10_000,
        aggroRange: 1,
        leashRange: 12,
        respawnMs: 10_000,
        xp: 0,
        peaceful: true,
        wanderRadius: 0,
        interactive: true,
        mapIcon: 'quest',
        ...extra,
    };
}
/** A piece in its four rarities: the one bought counts, and so does its rarer twin found in the field. */
export function anyRarity(id) {
    return [id, `${id}-rare`, `${id}-epic`, `${id}-legendary`];
}
//# sourceMappingURL=content.js.map